// extracted by css-extract-rspack-plugin
export default {"control":"ControlViewBottom_control__yOFqT","maxHeight":"ControlViewBottom_maxHeight__xQpYI"};